import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { BehaviorSubject } from 'rxjs';
declare var io: any;

@Injectable()
export class SocketService {
  socket = null;
  onDriverLocation: BehaviorSubject<any>;
  onNewOrder: BehaviorSubject<any>;
  onTripUpdate: BehaviorSubject<any>;
  onDriverStats: BehaviorSubject<any>;

  private tripUpdateListenerRegistered = false;
  private driverLocationListenerRegistered = false;
  private driverStatusListenerRegistered = false;
  private newOrderListenerRegistered = false;

  constructor() {
  }

  connect(from: string = 'DEFAULT') {
    return new Promise((resolve, reject) => {
      if (this.socket && this.socket.connected) {
        resolve(true);
        return;
      }
      this.socket = io(environment.NODE_API_URL);
      this.socket.on('connect', () => {
        console.log(`${from}: Socket Connected Successfully`);
        resolve(true);
      });
      this.socket.on('connect_error', (err) => {
        console.log(`${from}: Socket connect error`, err);
        reject(err);
      });
    });
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
      this.tripUpdateListenerRegistered = false;
      this.driverLocationListenerRegistered = false;
      this.driverStatusListenerRegistered = false;
      this.newOrderListenerRegistered = false;
    }
  }

  registerTripUpdateListener() {
    if (!this.socket) {
      return false;
    }
    if (!this.onTripUpdate) {
      this.onTripUpdate = new BehaviorSubject(null);
    }
    if (!this.tripUpdateListenerRegistered) {
      this.tripUpdateListenerRegistered = true;
      this.socket.on('trip-update', (data) => {
        this.onTripUpdate.next(data);
      });
    }
    return true;
  }

  registerNewOrderListener() {
    if (!this.socket) {
      return false;
    }
    if (!this.onNewOrder) {
      this.onNewOrder = new BehaviorSubject(null);
    }
    if (!this.newOrderListenerRegistered) {
      this.newOrderListenerRegistered = true;
      this.socket.on('new-order', (data) => {
        this.onNewOrder.next(data);
      });
    }
    return true;
  }

  registerDriverLocationListener() {
    if (!this.socket) {
      return false;
    }
    if (!this.onDriverLocation) {
      this.onDriverLocation = new BehaviorSubject(null);
    }
    if (!this.driverLocationListenerRegistered) {
      this.driverLocationListenerRegistered = true;
      this.socket.on('driver-location', (data) => {
        this.onDriverLocation.next(data);
      });
    }
    return true;
  }

  registerDriverStatusListener() {
    if (!this.socket) {
      return false;
    }
    if (!this.onDriverStats) {
      this.onDriverStats = new BehaviorSubject(null);
    }
    if (!this.driverStatusListenerRegistered) {
      this.driverStatusListenerRegistered = true;
      this.socket.on('DRIVER_STATUS', (data) => {
        this.onDriverStats.next(data);
      });
    }
    return true;
  }

}
